// Small "time ago" formatter for the GBP screen's stale-data stamp (design
// brief §5.6 — "Updated 3 hours ago", never alarming, never a fabricated
// value). Deliberately takes a concrete epoch-ms timestamp, never invents
// one — callers must not pass a fallback when a part has never successfully
// fetched (GbpPart's ok:false branch carries fetchedAt as optional for
// exactly that reason; the caller's job is to omit the stamp, not guess).
export function formatUpdatedAgo(fetchedAtMs: number, now: number = Date.now()): string {
  const diffMs = Math.max(0, now - fetchedAtMs);
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return 'Updated just now';
  if (minutes < 60) return `Updated ${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Updated ${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.floor(hours / 24);
  return `Updated ${days} day${days === 1 ? '' : 's'} ago`;
}
